export default {
    fsmRoute_modal_delete_title: "Borrar puntos de la ruta",
    fsmRoute_modal_delete_point: "¿Estás seguro de que quieres borrar todos los puntos de la ruta?, No se puede guardar una ruta sin puntos",
    fsmRoute_modal_delete_success: "Puntos borrados correctamente"
}